var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AdminOcupationBuilderList } from '../builders/adminOcupationList-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class AdminOcupationApiService {
    constructor(authenticatedApi) {
        this.authenticatedApi = authenticatedApi;
    }
    listAdminOcupation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminlot/ocupation_report`, payload).toPromise();
            return AdminOcupationBuilderList.buildAdminOcupationList(response);
        });
    }
}
AdminOcupationApiService.ɵfac = function AdminOcupationApiService_Factory(t) { return new (t || AdminOcupationApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
AdminOcupationApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AdminOcupationApiService, factory: AdminOcupationApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AdminOcupationApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=admin-ocupation-api.service.js.map